import { render, staticRenderFns } from "./roomInfoModule2.vue?vue&type=template&id=4f060716&scoped=true"
import script from "./roomInfoModule2.vue?vue&type=script&lang=js"
export * from "./roomInfoModule2.vue?vue&type=script&lang=js"
import style0 from "./roomInfoModule2.vue?vue&type=style&index=0&id=4f060716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f060716",
  null
  
)

export default component.exports